import { XMarkIcon }               from '@heroicons/react/20/solid'
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline'
import { FolderIcon }              from '@heroicons/react/24/solid'
import { useEffect, useState }     from 'react'
import { Link }                    from 'react-router-dom'
import { assetFilePath }           from '../../utilities'
import { Image }                   from '../Image'

interface RecentSearchesProps
{
  query: string
  loading: boolean
  onClose?: () => void
  type: string
  handleDownload?: ( e: any, file: any ) => void
}

export default function RecentSearches( props: RecentSearchesProps ): JSX.Element {
  const { query, onClose, type, handleDownload } = props
  const [ searches, setSearches ]                = useState( [] )
  const STORAGE_KEY                              = `bhm_recent_search_${ type }`
  const LOGO_URL                                 = 'https://www.bananamoon-thehub.co.uk/images/bananamoon.jpg'

  const removeSearch: any = ( event: any ): void => {
    event.preventDefault()
    event.stopPropagation()
    const queryKey: any            = event.currentTarget.dataset.query
    const existingArrayStr: string = localStorage.getItem( STORAGE_KEY )

    if ( existingArrayStr ) {
      const arr: any = JSON.parse( existingArrayStr ).filter( ( s: any ): any => s.query !== queryKey )
      localStorage.setItem( STORAGE_KEY, JSON.stringify( arr ) )
      setSearches( arr )
    }
  }

  useEffect( function setRecentSearches(): void {
    const existingArrayStr: string = localStorage.getItem( STORAGE_KEY )

    if ( existingArrayStr ) {
      setSearches( JSON.parse( existingArrayStr ).reverse() )
    }
  }, [ query ] )

  const markup: any = ( search: any ): any => (
    <div className="flex items-center">
      <div className="flex items-center gap-x-2 flex-1">
        { type === 'documents' && search.folder === 'true' &&
          <FolderIcon className="text-blue-secondary w-5 h-5" />
        }

        { type === 'documents' && search.folder !== 'true' &&
          <Image
            src={ assetFilePath( search.extension ) }
            defaultSrc={ assetFilePath( search.extension ) }
            klass="w-5 h-5"
          />
        }

        { type === 'forum' &&
          <ChatBubbleLeftRightIcon className="w-5 h-5" />
        }

        <div className="flex-1 truncate text-sm max-w-[90%]">{ search.title }</div>
      </div>

      <div>
        <button title="Remove this search" data-query={ search.query } className="relative z-50" type="button" onClick={ removeSearch }>
          <XMarkIcon className="w-5 h-5 text-gray-500 hover:text-black" />
        </button>
      </div>
    </div>
  )

  return (
    <div className="border-t">
      <div className="font-medium mt-3 pb-3 px-4 border-b">
        Recent
      </div>

      { searches.length > 0 ? (
        <ul role="listbox" className="divide-y">
          { searches.map( ( search: any, idx: number ) => (
            <li key={ idx } role="option" className={ `hover:bg-gray-50 px-4 py-2${ idx === ( searches.length - 1 ) ? ' rounded-b-2xl' : '' }` }>
              { ( ( type === 'documents' && search.folder === 'true' ) || type === 'forum' ) &&
                <Link to={ search.path } onClick={ onClose }>
                  { markup( search ) }
                </Link>
              }

              { type === 'documents' && search.folder !== 'true' &&
                <div
                  className="flex-1 w-full text-start cursor-pointer"
                  data-query={ search.query }
                  onClick={ ( e: any ): void => {
                    if ( search.file ) {
                      handleDownload( e, search.file )
                    } else {
                      removeSearch( e )
                    }

                    onClose()
                  } }
                >
                  { markup( search ) }
                </div>
              }

              { ( type === 'products_settings' || type.startsWith( 'shop' ) ) &&
                <Link to={ search.path } onClick={ onClose }>
                  { markup( search ) }
                </Link>
              }
            </li>
          ) ) }
        </ul>
      ) : (
          <div className="flex flex-col items-center justify-center mt-3">
            <Image src={ LOGO_URL } defaultSrc={ LOGO_URL } />
            <p className="text-center text-sm font-medium">You have no recent searches</p>
          </div>
        ) }
    </div>
  )
}
